import React from "react";
import Styles from "./styles";

function SeparatorLine({ color = "#D7D7D7", ...props }) {
  return <Styles color={color} {...props} />;
}

export default SeparatorLine;
